import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr;
  min-height: 50vh;
  position: relative;
`;

export const Container = styled.div`
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #ffffff 50%,
    #f5f5f6 51%,
    #a1a6ac 100%
  );
  grid-column: 1;
  grid-row: 2;
  height: 320px;
  pointer-events: none;

  @media (min-width: ${legacyBreakpoints.m}px) {
    height: 550px;
  }
`;

export const Vehicle = styled.img`
  display: block;
  margin: 0 auto;
  max-height: 100%;
  max-width: 600px;
  object-fit: cover;
  width: 100%;
  transform: translateY(-5%);

  @media (min-width: ${legacyBreakpoints.m}px) {
    max-width: 800px;
  }

  @media (min-width: ${legacyBreakpoints.l}px) {
    transform: translateY(0);
  }

  @media (min-width: ${legacyBreakpoints.xl}px) {
    max-width: 1000px;
  }
`;

export const ImageDisclaimer = styled.div`
  bottom: 24px;
  position: absolute;
  text-align: center;
  width: 100%;
  height: 59px;
  margin: 0 auto;
`;
